import { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { Form } from "react-bootstrap";
import toast from "react-hot-toast";
import * as _ from "lodash";
import { MapComponent } from "./components/MapComponent";
import { useListaEmpresasPortal } from "@/hooks/useEmpresas";
import { useSendEmail } from "@/hooks/useHome";
import { useAuth } from "@/_zustand/auth";
import { useMachine } from "@/_zustand/machine";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

export const ContactCompanyPage = () => {
  const { user } = useAuth();
  const { empresa_id } = useMachine();
  const sendEmail = useSendEmail();
  const comercios = useListaEmpresasPortal();
  const [selectComercio, setSelectComerio] = useState("");
  const [msg, setMsg] = useState("");
  const defaultValues = {
    name: user.usuario_nombre,
    lastname: user.usuario_apellido,
    msg: "",
    email: user.usuario_correo,
    whatsapp: user.usuario_telefono,
    nombreComercial: "",
  };

  useEffect(() => {
    if (empresa_id && comercios.data) {
      const currentComercio = comercios.data.find(
        (c) => Number(c.empresa_id) === Number(empresa_id),
      );
      if (currentComercio) {
        setSelectComerio(currentComercio.empresa_nomcom);
      }
    }
  }, [empresa_id, comercios.data]);

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({ defaultValues });
  //aqui
  const getFormErrorMessage = (name) =>
    errors[name] && (
      <small className="text-danger">{errors[name].message}</small>
    );

  const onSubmit = (formData) => {
    let comercio =
      selectComercio == "" ? (comercios.data?.[0]?.empresa_nomcom ?? "") : msg;
    let dataSend = {
      nombre: formData.name,
      apellido: formData.lastname,
      correo: formData.email,
      whatsapp: formData.whatsapp,
      mensaje: msg,
      nombreComercial: comercio,
    };

    sendEmail
      .mutateAsync(dataSend)
      .then(() => {
        toast.success("Se ha enviado el correo exitosamente");
        // window.location.reload();
      })
      .catch(() => {
        toast.error("Ha ocurrido un error al enviar el correo");
      });

    // }
  };

  return (
    <section className="container my-5" style={{ flexGrow: 1 }}>
      <div className="row d-flex justify-content-center ">
        <h2 className="contact-title">
          <span>¡Contáctate con nosotros!</span>
        </h2>
        <div className="col-md-6 p-2 map">
          <MapComponent />
        </div>
        <div className="col-md-6 contact-box">
          <Form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="col-6 about-us-pb">
                {/* <Form.Control required type="text" placeholder="Nombre" onChange={(e) => setName(e.target.value)}/>
                    <Form.Control.Feedback>Looks good!</Form.Control.Feedback> */}
                <label htmlFor="name" className="mb-2 about-us-textcolor">
                  Nombres
                </label>
                <Controller
                  name="name"
                  control={control}
                  rules={{ required: "Debe indicar el nombre" }}
                  render={({ field, fieldState }) => (
                    <Form.Group className="position-relative mb-2 ">
                      <Form.Control
                        type="text"
                        placeholder={user.usuario_nombre}
                        id={field.name}
                        {...field}
                        isInvalid={fieldState.invalid}
                      />
                      {getFormErrorMessage("name")}
                    </Form.Group>
                  )}
                />
              </div>
              <div className="col-6 about-us-pb">
                <label className="mb-2 about-us-textcolor">Apellidos</label>
                <Controller
                  name="lastname"
                  control={control}
                  rules={{ required: "Debe indicar el apellido" }}
                  render={({ field, fieldState }) => (
                    <Form.Group className="position-relative mb-2 ">
                      <Form.Control
                        type="text"
                        placeholder={user.usuario_apellido}
                        id={field.name}
                        {...field}
                        isInvalid={fieldState.invalid}
                      />
                      {getFormErrorMessage("lastName")}
                    </Form.Group>
                  )}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-6 about-us-pb">
                {/* <Form.Control type="email" placeholder="correo@example.com" onChange={(e) => setEmail(e.target.value)}/>
                    <Form.Control.Feedback type="invalid">
                      Por favor ingrese un correo válido.
                    </Form.Control.Feedback> */}
                <label className="mb-2 about-us-textcolor">Correo</label>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: "Debe indicar el correo",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Correo no válido",
                    },
                  }}
                  render={({ field, fieldState }) => (
                    <Form.Group className="position-relative mb-2 ">
                      <Form.Control
                        type="email"
                        placeholder={user.usuario_correo}
                        id={field.email}
                        {...field}
                        isInvalid={fieldState.invalid}
                      />
                      {getFormErrorMessage("email")}
                    </Form.Group>
                  )}
                />
                {/* <Controller name="usuariocorreo" control={control}
                rules={{ required: 'Debe indicar el correo', pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Correo no válido' } }}
                render={({ field, fieldState }) => (
                  <Form.Group className="position-relative mb-2 ">
                    <Form.Label className="mb-2">Email <span className='text-danger'>*</span></Form.Label>
                    <Form.Control type="text" placeholder="Email" id={field.name} {...field} isInvalid={fieldState.invalid} />
                    {getFormErrorMessage("usuario_correo")}
                  </Form.Group>
                )}
              /> */}
              </div>
              <div className="col-6 about-us-pb">
                <label className="mb-2 about-us-textcolor">
                  Teléfono (whatsapp)
                </label>
                {/* <Controller name="whatsapp" control={control}
                      rules={{ required: "Debe indicar el whatsapp" }}
                      render={({ field, fieldState }) => (
                        <Form.Group className="position-relative mb-2 ">
                          <Form.Control type="number" placeholder="whatsapp" 
                          id={field.name} {...field} isInvalid={fieldState.invalid} />
                          {getFormErrorMessage("whatsapp")}
                        </Form.Group>
                      )}
                    /> */}
                <Controller
                  name="whatsapp"
                  control={control}
                  defaultValue={user.usuario_telefono}
                  render={({ field }) => (
                    <PhoneInput
                      {...field}
                      country={"cl"}
                      enableSearch={true}
                      countryCodeEditable={false}
                      inputStyle={{ width: "100%" }}
                    />
                  )}
                />
              </div>
            </div>

            <div className="row" style={{ marginBottom: "1.5rem" }}>
              <label className="mb-2 about-us-textcolor">
                Seleccione una empresa
              </label>
              <Controller
                name="nombreComercial"
                control={control}
                render={({ field, fieldState }) => (
                  <Form.Group>
                    <Form.Select
                      id={field.value}
                      {...field}
                      isInvalid={fieldState.invalid}
                      as="select"
                      value={selectComercio}
                      disabled={!!empresa_id}
                      onChange={(e) => {
                        setSelectComerio(e.target.value);
                      }}
                    >
                      {/* <option value="0">Seleccione una empresa</option> */}
                      {_.size(comercios.data) > 0 &&
                        comercios.data
                          .filter((comercio) => {
                            if (empresa_id) {
                              return (
                                Number(comercio.empresa_id) ===
                                Number(empresa_id)
                              );
                            }
                            return true;
                          })
                          .map((comercio) => (
                            <option
                              key={comercio.empresa_id}
                              value={comercio.empresa_nomcom}
                            >
                              {comercio.empresa_nomcom}
                            </option>
                          ))}
                    </Form.Select>
                  </Form.Group>
                )}
              />
            </div>

            <div className="row" style={{ marginBottom: "1.5rem" }}>
              <label className="mb-2 about-us-textcolor">
                Escribe tu mensaje
              </label>
              <Form.Group>
                <Form.Control
                  as="textarea"
                  placeholder="Mensaje"
                  rows={3}
                  onChange={(e) => setMsg(e.target.value)}
                />
              </Form.Group>
            </div>

            <div
              className="row"
              style={{ paddingLeft: "10px", paddingRight: "10px" }}
            >
              <button
                className="btn rounded-6 montserrat-bold text-white"
                type="submit"
                onClick={handleSubmit}
                style={{ backgroundColor: "#8DC200", width: "100%" }}
              >
                Enviar
              </button>
            </div>
          </Form>
        </div>
      </div>
    </section>
  );
};
